function TipsSo(){
    return (
        <>
        <div className="Tips">
            <div className="haye">
            <div className="tips_container">
                <div className="left_tips">
                <img src="/Images/01.png"  alt="image_tips"/>
                </div>
                <div className="right_tips">
                    <div className="tap">
                        <div className="icon">
                        <i className="fa-solid fa-circle-check"></i>
                        </div>
                        <div className="qoraal">
                            <h2>Dooro</h2>
                            <p className="info_tips">Dooro Cv-ga ku qanciya ee kamida nashqadaha diyaarsan</p>
                        </div>
                    </div>
                    <div className="tap">
                        <div className="icon">
                        <i className="fa-solid fa-circle-check"></i>
                        </div>
                        <div className="qoraal">
                        <h2>Diyaarso</h2>
                        <p  className="info_tips">Diyaarso cv-ga aad dooratay kuna buuxi Macluumaadkaaga</p>
                        </div>
                    </div>
                    <div className="tap">
                        <div className="icon">
                        <i className="fa-solid fa-circle-check"></i>
                        </div>
                        <div className="qoraal">
                        <h2>Dajiso</h2>
                        <p className="info_tips">Kadib Dajiso cv-gaaga adoo bixinaya Qiimaha oo Ka yar 5$</p>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
        
        </>
    )
}


export default TipsSo